export function commonExample(): void {
  console.log("common example output");
}
